<script setup lang="ts">
import { isUnauthenticatedLiquidityPortal } from '../utils/guest-portal-url'

const isLiquidity = ref(isUnauthenticatedLiquidityPortal(useRequestURL().href))
</script>

<template>
  <div
    data-layout="auth/guest"
    class="min-h-screen font-normal pt-4 bg-no-repeat bg-cover"
    :class="isLiquidity
      ? 'text-white bg-[url(/auth/prelogin-liquidity.svg)] bg-dark'
      : 'bg-neutral-400 text-primal bg bg-[url(/auth/prelogin.svg)]'"
  >
    <div class="max-w-forgd mx-auto px-4 sm:px-6 flex flex-col items-center justify-center py-14">
      <div class="mb-8">
        <CoreLogo :dark="!isLiquidity" />
      </div>
      <div class="max-w-full">
        <slot />
      </div>
    </div>
  </div>
</template>
